import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "section-intro",
  id: "intro"
}
const _hoisted_2 = { class: "profile-card" }
const _hoisted_3 = { class: "info-left" }
const _hoisted_4 = { class: "info-right" }
const _hoisted_5 = { class: "info-container" }
const _hoisted_6 = { class: "page-my-name" }
const _hoisted_7 = ["textContent"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_9 = ["textContent"]
const _hoisted_10 = ["textContent"]
const _hoisted_11 = { class: "social-links" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_avatar = _resolveComponent("avatar")!
  const _component_social_links = _resolveComponent("social-links")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_avatar)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", _hoisted_6, [
            _createElementVNode("span", {
              class: "name first-name",
              textContent: _toDisplayString(_ctx.Info.FirstName)
            }, null, 8, _hoisted_7),
            _hoisted_8,
            _createElementVNode("span", {
              class: "name last-name",
              textContent: _toDisplayString(_ctx.Info.LastName)
            }, null, 8, _hoisted_9)
          ]),
          _createElementVNode("p", {
            class: "description",
            textContent: _toDisplayString(_ctx.Info.ShortDescription)
          }, null, 8, _hoisted_10)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_social_links)
        ])
      ])
    ])
  ]))
}